import clsx from 'clsx';
import { getInitials } from '../../../vacations.definitions';

export interface VacationAvatarProps {
    name: string;
    photoUrl?: string | null;
    size?: 'sm' | 'lg';
}

const SIZE_CLASSES = {
    sm: 'h-8 w-8 text-xs',
    lg: 'h-14 w-14 text-sm',
};

export function VacationAvatar({ name, photoUrl, size = 'sm' }: VacationAvatarProps) {
    if (photoUrl) {
        return (
            <img
                src={photoUrl}
                alt=""
                referrerPolicy="no-referrer"
                className={clsx('shrink-0 rounded-full object-cover', SIZE_CLASSES[size])}
            />
        );
    }

    return (
        <span
            aria-hidden="true"
            className={clsx('flex shrink-0 items-center justify-center rounded-full bg-primary-100 font-bold text-primary-700 font-montserrat', SIZE_CLASSES[size])}
        >
            {getInitials(name)}
        </span>
    );
}

export default VacationAvatar;
